import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar, } from '@mui/x-data-grid-premium';
import { useCallback, useState } from "react";
import { Button, Col, FloatingLabel, Form, Modal, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useAddVehicleTypePricingMutation, useDeleteVehicleListMutation, useGetAllVehicleRateTypeQuery, useGetAllVehicleTypePricingQuery, useGetDivisionListPricingQuery, useLazyGetVehicleDetailsByIDQuery, useUpdateVehicleListMutation } from "../../../../../features/vehicle/vehicledespSlice";
import { useGetVehicleQuery } from "../../../../../features/vehicle/vehicleDetailSlice";
import Dialog from "../../../../designSystem/Dialog";
import TextField from "../../../../designSystem/TextField";
import errorHandler from "../../../../hooks/ErrorHanlder";

const CreateVehicle = () => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
    defaultValues: {
      vehicleType: '',
      description: '',
      divisionId: '',
      RateType: '',
      vehicleID: ''
    }
  });

  const { data: divisionList } = useGetDivisionListPricingQuery()
  const { data: vehicleList, refetch: vehicleData } = useGetVehicleQuery()
  const [addVehicleType] = useAddVehicleTypePricingMutation();
  const [deleteVehicleList] = useDeleteVehicleListMutation()
  const { data: getVehicleType, refetch } = useGetAllVehicleTypePricingQuery()
  const { refetch: refetch_vehicles } = useGetAllVehicleRateTypeQuery()
  const [isShow, setIsShow] = useState(false);
  const [getVehicleDetails] = useLazyGetVehicleDetailsByIDQuery();
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [updateVehicleList] = useUpdateVehicleListMutation();
  const [show, setShow] = useState(false);

  const deleteHandler = async () => {
    try {
      await deleteVehicleList(deleteId).unwrap();
      toast.success("Vehicle deleted successfully", { position: "top-center", })
      refetch()
      setOpen(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  const onSubmit = async ({ vehicleID, ...payload }) => {
    try {
      await addVehicleType(payload).unwrap();
      toast.success("Vehicle Added Successfully", {
        position: "top-center",
      })
      refetch()
      refetch_vehicles()
      reset();
      vehicleData()
    } catch (error) {
      errorHandler(error);
    }
  }

  const onUpdate = async (addVehicleList) => {
    try {
      await updateVehicleList(addVehicleList).unwrap();
      toast.success("Data Updated Sccessfully !", {
        position: "top-center",
      })
      setShow(false);
      refetch()
      reset();
      vehicleData()
    } catch (error) {
      errorHandler(error);
    }
  }
  const onClickEdit = useCallback(async (id) => {
    const vehicle = await getVehicleDetails(id).unwrap()
    setValue("vehicleID", vehicle?.data?.vehicleID)
    setValue("vehicleType", vehicle?.data?.vehicleType)
    setValue("description", vehicle?.data?.description)
    setValue("divisionId", vehicle?.data?.divisionId)
    setValue("RateType", vehicle?.data?.rateType)
    setShow(true)
  }, [getVehicleDetails, setValue])

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 120,
      disableClickEventBubbling: true,
      renderCell: (data) => {
        const onClickRemove = (e) => {
          e.stopPropagation();
          setDeleteId(data?.id)
          setOpen(true);
        };

        return (
          <>
            <div className="action_btn">
              <span className="edit_btn" onClick={() => onClickEdit(data?.row?.id)}><Edit /></span>
              <span className="del_btn" onClick={onClickRemove}><Delete /></span>
            </div>
            <Dialog disableBackdrop title="Delete Confirmation" show={open} onClose={() => setOpen(false)} description="Are you sure you want to delete this row?" onSubmit={deleteHandler} />
          </>
        )
      },
    },
    { field: "vehicleType", headerName: "Vehicle Type", width: 200 },
    { field: "description", headerName: "Description Type", width: 200 },
    { field: "divisionName", headerName: "Division Name", width: 200 },
    { field: "rateType", headerName: "Rate Type", width: 200 },
  ];

  const rows = (getVehicleType?.data || []).map((data) => {
    return {
      id: data?.vehicleID,
      vehicleType: data?.vehicleType,
      description: data?.description,
      divisionName: data?.divisionName,
      rateType: data?.rateType,
    }
  })

  const rateTypes = ['LOCAL', 'CWT', 'PALLET', 'DISTANCE-BASED'];
  const onCancel = () => {
    setShow(false);
    reset();
  }

  return (
    <>
      <Button onClick={() => setIsShow(true)} variant="primary" style={{ width: "20%" }}>
        Create Vehicle
      </Button>
      <Modal
        size="xl"
        show={isShow}
        onHide={() => setIsShow(false)}
        aria-labelledby="example-modal-sizes-title-md"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-md">
            Add Vehicle
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={3}>
              <TextField label="Vehicle Type" {...register('vehicleType', { required: 'Field is required' })} error={errors?.vehicleType?.message} />
            </Col>
            <Col sm={2}>
              <TextField label="Description Type" {...register('description', { required: 'Field is required' })} error={errors?.description?.message} />
            </Col>
            <Col sm={2}>
              <div className="form-floating">
                <Form.Group controlId="drivernumber">
                  <FloatingLabel controlId="floatingSelectGrid" label="Select division">
                    <Form.Select aria-label="Floating label select example" name="divisionId" {...register('divisionId', { required: 'Field is required' })}>
                      <option value="">Select</option>
                      {divisionList?.data?.map((data) => (
                        <option key={data?.divisionId} value={data?.divisionId} >{data?.divisionName}</option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                {errors?.divisionId?.message && <p className="text-danger m-0">{errors?.divisionId?.message}</p>}
              </div>
            </Col>
            <Col sm={3}>
              <div className="form-floating">
                <Form.Group controlId="rateType">
                  <FloatingLabel controlId="floatingSelectGrid" label="Select Rate Type">
                    <Form.Select aria-label="Floating label select example" name="RateType" {...register('RateType', { required: 'Field is required' })}>
                      <option value="">Select</option>
                      {rateTypes.map((data) => (
                        <option key={data} value={data} >{data}</option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Form.Group>
                {errors?.RateType?.message && <p className="text-danger m-0">{errors?.RateType?.message}</p>}
              </div>
            </Col>
            <Col sm={2}>
              {!show ?
                <div className="section_action_btn">
                  <div className="add_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><AddCircle /> Add</button></div>
                </div>
                :
                <div className="section_action_btn">
                  <div className="save_btn"><button type="button" className="btn" onClick={handleSubmit(onUpdate)} ><Save /> Save</button></div>
                  <div><button type="button" className="btn btn-outline-primary h-100 ms-1" onClick={onCancel} > Cancel</button></div>
                </div>
              }
            </Col>
          </Row>
          <div className="user-role-table" style={{ height: "500px" }}>
            <h6>List of Vehicle</h6>
            <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default CreateVehicle;
